/* global  BMapGL */
import { loadBMap } from './loadBMap';
import { basicConfig, pointContent } from './mapConfig';
loadBMap();
class MapBase {
    constructor(elem) {
        this.map = new BMapGL.Map(elem); // 实例化地图对象
        // 允许地图可被鼠标滚轮缩放
        this.map.enableScrollWheelZoom();
        // 开启地图的平移缩放控件
        this.addNavigationControl();
        // 设置默认中心点
        this.setDefaultCenterPoint();
    }
    // 开启地图的平移缩放控件
    addNavigationControl() {
        const zoomCtrl = new BMapGL.ZoomControl(); // 添加缩放控件
        this.map.addControl(zoomCtrl);
    }
    // 设置默认中心点
    setDefaultCenterPoint() {
        const { centerPointLongitude: longitude, centerPointLatitude: latitude, mapZoom } = basicConfig;
        this.map.centerAndZoom(this.toAxisPoint(longitude, latitude), mapZoom);
    }
    /**
     * @description 矩形区域大小
     * @param {Number} w 宽度
     * @param {Number} h 高度
     */
    setSize(w, h) {
        return new BMapGL.Size(w, h);
    }
    /**
     *
     * @param {String} url icon地址
     * @param {Object} size size对象
     */
    setIcon(url, size) {
        return new BMapGL.Icon(url, size);
    }
    /**
     * @description 将经纬度转为坐标点
     * @param {Objcet} longitude 经度
     * @param {Objcet} latitude 纬度
     */
    toAxisPoint(longitude, latitude) {
        return new BMapGL.Point(longitude, latitude);
    }
    /**
     * @description 添加图标标注
     * @param {Object} point 点的坐标
     * @param {String} url 图标url
     * @param {Number} width 图标宽度，默认24px
     * @param {Number} height 图标高度，默认36px
     */
    addIconMarker (point, url, width = 24, height = 36, offset = this.setSize(0, 0)) {
        const size = this.setSize(width, height);
        const icon = this.setIcon(url, size);
        icon.setImageSize(size);
        const marker = new BMapGL.Marker(point, { offset, icon });
        marker.disableDragging(); // 禁止拖拽图标
        this.map.addOverlay(marker);
        return marker;
    }
    /**
     * @description 添加文本标注
     * @param {Number} point 当前标注所在的经纬度
     * @param {String} htmlTemp html模板内容
     * @param {String} styleConfig 文本内容样式
     */
    addLabelMarker(point, htmlTemp, style) {
        const label = new BMapGL.Label(htmlTemp, {
            position: point,
            offset: this.setSize(0, -60)
        });
        label.setStyle(style);
        this.map.addOverlay(label);
        return label;
    }
    /**
 * @description 车辆轨迹注点
 * @param {Object} point 开始和结束坐标
 * @param {String} url 图标url
 * @param {Number} width 图标宽度，默认6px
 * @param {Number} height 图标高度，默认6px
 * @param {Object} pointData 轨迹点信息
 * @returns {Object} 返回注册的标注点
*/
    createCarRouteMarker (point, url, width = 6, height = 6, pointData, offset = this.setSize(0, 0)) {
        const size = this.setSize(width, height);
        const icon = this.setIcon(url, size);
        icon.setImageSize(size);
        // 创建Marker实例
        const marker = new BMapGL.Marker(point, {
            icon,
            offset
        });
        marker.disableDragging(); // 禁止拖拽图标
        this.map.addOverlay(marker);
        const content = pointContent(pointData);
        this.hoverClickHandler(this.map, {
            marker,
            content,
            point
        });
        return marker;
    }

    /**
 * @description 标注弹窗移入移出事件
 * @param {Object} map 地图实例
 * @param {Object} marker 标注点实例
 * @param {String} content 弹窗内容
 * @param {Object} point 标注点坐标
 */

    hoverClickHandler (map, { marker, content, point }) {
        const infoWindow = new BMapGL.InfoWindow(content, {
            title: '当前轨迹点'
        });
        marker.addEventListener('mouseover', function () {
            map.openInfoWindow(infoWindow, point); // 开启信息窗口
        });
        marker.addEventListener('mouseout', function () {
            map.closeInfoWindow(infoWindow, point); // 隐藏信息窗口
        });
    }
}

export default MapBase;
